const TriggerReducers = (state = false, action) => {
  switch (action.type) {
    case "globalTrigger":
      return !state;
    default:
      return state;
  }
};
export default TriggerReducers;
